export default __webpack_public_path__ + "static/media/ic_gmx_avax.5c59ab2b.svg";